import {
  createStyles,
  Paper,
  Title,
  Text,
  Button,
  Container,
  Stack
} from "@mantine/core";
import { useWallet } from "@buidlerlabs/hashgraph-react-wallets";
import { ConnectWalletBtn } from "../components/reusable/ConnectWalletBtn";

const AuthPage = ({ isAuthenticating, onAuthenticate }) => {
  const { classes } = useStyles();
  const { isConnected } = useWallet();

  return (
    <Container size={460} my={50}>
      <Title className={classes.title} align="center">
        HeadStarter - Authentication
      </Title>
      <Text color="dimmed" size="sm" align="center">
        In order to use the administrative panel, you have to be authenticated
      </Text>

      <Paper shadow="md" p={30} radius="md" mt="xl" withBorder>
        <Stack spacing={isConnected ? 10 : 0}>
          {isConnected && (
            <Button
              className={classes.control}
              onClick={onAuthenticate}
              loading={isAuthenticating}
            >
              Authenticate
            </Button>
          )}
          <ConnectWalletBtn
            disabled={isAuthenticating}
            connectLabel="Connect and authenticate"
          />
        </Stack>
      </Paper>
    </Container>
  );
};

const useStyles = createStyles((theme) => ({
  title: {
    fontSize: 26,
    fontWeight: 900
  },

  control: {
    [theme.fn.smallerThan("xs")]: {
      width: "100%",
      textAlign: "center"
    }
  }
}));

export default AuthPage;
